import { render, staticRenderFns, recyclableRender, components } from "./withdrawal.vue?vue&type=template&id=0969ec26&scoped=true&"
var renderjs
import script from "./withdrawal.vue?vue&type=script&lang=js&"
export * from "./withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./withdrawal.vue?vue&type=style&index=1&id=0969ec26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0969ec26",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/withdrawal/withdrawal.vue"
export default component.exports